import { useRouter } from 'next/router';
import type { FC } from 'react';
import { useEffect, useState } from 'react';
import type { ICompleteProfileForm } from '@/Module/Auth/Component';
import { AuthRegisterModal, ReferTypeModal } from '@/Module/Auth/Component';
import { isRubikaUser, isShadUser } from '@/Module/Auth/Helper';
import { authUpdatePersonAction } from '@/Module/Auth/Store/Action';
import { authSetIsTransitioningAction, setSectionWelcome } from '@/Module/Auth/Store/Slice/AuthSlice';
import { useAppDispatch, useAppSelector } from '@/Module/Store/Hook';
const SHOULD_HIDE = (pathname: string) => pathname.includes('auth') || pathname.includes('subscription');
const AuthConfirmFormModal: FC = () => {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const person = useAppSelector(state => state.auth.person)!;
  const loggedIn = useAppSelector(state => state.auth.isLoggedIn);
  const profileCompleted = person?.isComplete;
  const [step, setStep] = useState(profileCompleted ? 510 : 1); // 1 | 2 | 510
  const [openRefer, setOpenRefer] = useState(false);
  const isRubika = isRubikaUser();
  const isShad = isShadUser();
  const persistStep = (value: number) => {
    localStorage.setItem('step', value.toString());
    dispatch(setSectionWelcome(value));
    setStep(value);
  };
  const handleProfileSuccess = (payload: ICompleteProfileForm) => {
    dispatch(authUpdatePersonAction({
      id: person.id,
      fundametalId: person.fundametalId,
      gender: person.gender,
      name: payload.firstName,
      family: payload.lastName,
      gradeId: payload.grad.value,
      fieldId: payload.field?.value || null,
      birthDate: payload.birthDate!,
      stateId: payload.province?.value,
      cityId: payload.city?.value
    })).unwrap().then(() => {
      if (isRubika || isShad) {
        dispatch(authSetIsTransitioningAction(true));
        persistStep(510);
      } else {
        setOpenRefer(true);
        persistStep(2);
      }
    });
  };
  useEffect(() => {
    if (step === 2) return setOpenRefer(true);
    return setOpenRefer(false);
  }, [step]);
  if (!loggedIn || profileCompleted || SHOULD_HIDE(router.pathname)) return null;
  return step === 1 ? <AuthRegisterModal isOpen={!openRefer} onSuccess={handleProfileSuccess} data-sentry-element="AuthRegisterModal" data-sentry-component="AuthConfirmFormModal" data-sentry-source-file="AuthConfirmFormModal.tsx" /> : <ReferTypeModal isOpenRefer={openRefer} data-sentry-element="ReferTypeModal" data-sentry-component="AuthConfirmFormModal" data-sentry-source-file="AuthConfirmFormModal.tsx" />;
};
export default AuthConfirmFormModal;